<div class="card border mt-4 p-4">
  <h5 class="text-body-secondary">
    Question {{ currentQuestionIndex + 1 }} of {{ onboardingQuestions.length }}
  </h5>
  @if (currentQuestion) {
    <h4 class="pb-2">{{ currentQuestion.question }}?</h4>
    <div>
      <div
        class="questions"
        [class.column-2]="currentQuestion.options.length < 3"
      >
        @for (option of currentQuestion.options; track option) {
          <div
            class="question rounded"
            (click)="currentQuestion.value = option.value"
            [class.selected]="currentQuestion.value === option.value"
          >
            <div class="check-mark">
              <i-lucide name="check-circle" class="giant-icon"></i-lucide>
            </div>
            <p>
              {{ option.name }}
            </p>
          </div>
        }
      </div>

      <div class="d-flex flex-row justify-content-end mt-4">
        @if (currentQuestionIndex > 0) {
          <button type="button" class="btn btn-outline me-2" (click)="onBack()">
            Back
          </button>
        }
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!currentQuestion.optional && !currentQuestion.value"
          (click)="onNext()"
        >
          {{ nextButtonLabel }}
        </button>
      </div>
    </div>
  }
</div>
